import { UserAsset } from '@interfaces';

export type DecisionDocumentsState = Readonly<{
  loading: boolean;
  documents: UserAsset[];
  removingIds: string[];
}>;

export const initialState: DecisionDocumentsState = {
  loading: false,
  documents: [],
  removingIds: [],
};
